module.exports = __webpack_public_path__ + "img/toast_black.6cf06d9c.svg";